import { IdBuilding } from "../constants/IdBuilding";
import { utilAnimation } from "../utils/animation/utilAnimation";
import { errorAnimation, warnAnimation } from "../utils/logging/logging";
var BF2ProductionAnimator = /** @class */ (function () {
    function BF2ProductionAnimator(id, typeId) {
        var _this = this;
        this.id = id;
        this.typeId = typeId;
        this.anims = [];
        this.productionStep = 0;
        this.setCurrentProductionStep = function (step) {
            if (_this.productionStep === step) {
                return;
            }
            _this.productionStep = step;
            // Re-awake animations that are sleeping
            _this.anims.forEach(_this.nextAnim);
        };
        this.setContainer = function (container) {
            _this.container = container;
            if (_this.anims.length > 0) {
                _this.addAnimsToContainer();
            }
        };
        this.addAnimation = function (anim, anims, offsetRandomly) {
            var config = {
                anim: anim,
                states: anims,
            };
            _this.anims.push(config);
            _this.anims.sort(_this.animPositionYSorter);
            _this.addAnimsToContainer();
            if (offsetRandomly) {
                _this.startAnimWithRandomTimeout(config);
            }
            else {
                _this.nextAnim(config);
            }
        };
        this.addAnimsToContainer = function () {
            var isWindmillBuilding = _this.typeId === IdBuilding.Windmill;
            // Windmill is a special case, animation needs to be played instead of a sprite, so we remove it
            if (isWindmillBuilding && _this.container.children.length > 1) {
                try {
                    _this.container.removeChildAt(1);
                }
                catch (e) {
                    errorAnimation(e);
                }
            }
            var zIndex = Math.min(1, _this.container.children.length);
            _this.anims.forEach(function (config) { return _this.container.addChildAt(config.anim, zIndex); });
        };
        this.startAnimWithRandomTimeout = function (config) {
            setTimeout(function () { return _this.nextAnim(config); }, Math.random() * BF2ProductionAnimator.RandomInterval);
        };
        this.nextAnim = function (config) {
            // TODO: synchronize animations for goats.
            var animId = _this.getRandomAnimation(config.states[_this.productionStep]);
            // Special case. used for windmill
            // Won't continue playing animations
            if (animId == undefined) {
                var animState = config.states.find(function (state) { return state.length > 0; });
                var isWindmillBuilding = _this.typeId === IdBuilding.Windmill;
                if (animState != undefined) {
                    var track = _this.playAnim(config, animState[0]);
                    config.anim.state.timeScale = 0;
                    if (isWindmillBuilding) {
                        track.trackTime = BF2ProductionAnimator.WindmillAnimationStopTime;
                    }
                }
                return;
            }
            _this.playAnim(config, animId);
        };
        this.playAnim = function (config, animId) {
            if (utilAnimation.isAnimationEnabled()) {
                var animState_1 = config.anim.state;
                if (!animState_1.hasAnimation(animId)) {
                    warnAnimation("Animation not found by id " + animId);
                    _this.nextAnim(config);
                    return;
                }
                animState_1.listeners.forEach(function (listener) { return animState_1.removeListener(listener); });
                animState_1.addListener({
                    complete: function () { return _this.nextAnim(config); },
                });
                var track = animState_1.setAnimation(BF2ProductionAnimator.DefaultTrackIndex, animId, false);
                animState_1.timeScale = 1;
                return track;
            }
            return;
        };
        this.getRandomAnimation = function (ids) {
            var animIdx = Math.floor(Math.random() * ids.length);
            return ids[animIdx];
        };
        /**
         * This sorts the animations in reverse.
         * This is needed so that addChildAt(child, 1) can be used, which will reverse the order.
         */
        this.animPositionYSorter = function (a, b) { return b.anim.y - a.anim.y; };
    }
    BF2ProductionAnimator.RandomInterval = 1000;
    BF2ProductionAnimator.DefaultTrackIndex = 0;
    BF2ProductionAnimator.WindmillAnimationStopTime = 0.5;
    return BF2ProductionAnimator;
}());
export { BF2ProductionAnimator };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2ProductionAnimator.ts
// module id = 2195
// module chunks = 3